import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import _ from "lodash";

interface IHouse {
  id: number;
  title: string;
}

/*
* @deprecated 代码质量太差，废弃
**/
@Component({
  selector: "host-search-houses-with-group-and-type",
  templateUrl: "./search-houses-with-group-and-type.component.html",
  styleUrls: ["./search-houses-with-group-and-type.component.scss"],
})
export class SearchHousesWithGroupAndTypeComponent
  implements OnInit, OnChanges {
  @Input() defaultHouses: Array<Number> = null; // 修改某一条信息时，该信息已选择的房间
  @Input() selectedHouses: Array<Number> = null; // 一条手工单中，其它条信息，已选择的房间们
  @Input() selectedHouseCannotClick = true;
  @Input() allowMultiSelect = false;
  @Input() houseGroupList = [];
  @Input() houseTypeList = [];
  @Input() allHouseList = [];
  @Input() noBorder = false;
  @Input() filterBigPadding = false;
  @Input() showWidth = "472px";
  @Input() showHouseHeight = "305px";

  @Output() checkedHousesChange = new EventEmitter<Array<IHouse>>();
  @Output() groupChange = new EventEmitter();
  @Output() typeChange = new EventEmitter();

  checkedHouses: Array<IHouse> = [];

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes: ', changes)
    if (this.defaultHouses) {
      this.initDefaultHouses();

      if (changes['allHouseList'] && changes['allHouseList']['currentValue']) {
        this.initDefaultHouses();
      }
    }
    if (this.selectedHouses) {
      this.initSelectedHouses();
    }
  }

  initDefaultHouses() {
    this.checkedHouses = [];
    _.forEach(this.allHouseList, (type) => {
      _.forEach(type.houses, (house) => {
        if (_.indexOf(this.defaultHouses, house.house_id) !== -1) {
          house.checked = true;
          this.checkedHouses.push({
            id: house.house_id,
            title: house.house_title,
          });
        }
      });
    });
    this.checkedHousesChange.emit(this.checkedHouses);
  }

  initSelectedHouses() {
    _.forEach(this.allHouseList, (type) => {
      _.forEach(type.houses, (house) => {
        if (_.indexOf(this.selectedHouses, house.house_id) !== -1) {
          if (this.selectedHouseCannotClick) {
            house.disabled = true;
          } else {
            house.disabled = false;
            house.checked = true;
            this.checkedHouses.push({
              id: house.house_id,
              title: house.house_title,
            });
            this.checkedHousesChange.emit(this.checkedHouses);
          }
        } else {
          house.disabled = false;
          house.checked = false;
        }
      });
    });
  }

  checkGroup(index) {
    if (this.houseTypeList.length !== 0) {
      _.forEach(this.houseTypeList, (type) => {
        _.assign(type, {
          thisTypeChecked: false,
        });
      });
    }
    this.houseGroupList[index].thisGroupChecked = !this.houseGroupList[index]
      .thisGroupChecked;
    for (let i = 0; i < this.houseGroupList.length; i++) {
      if (i !== index) {
        this.houseGroupList[i].thisGroupChecked = false;
      }
    }
    this.checkedHouses = [];
    this.checkedHousesChange.emit(this.checkedHouses);
    this.groupChange.emit(this.houseGroupList[index].id);
  }

  checkType(index) {
    _.forEach(this.houseGroupList, (group) => {
      _.assign(group, {
        thisGroupChecked: false,
      });
    });
    this.houseTypeList[index].thisTypeChecked = !this.houseTypeList[index]
      .thisTypeChecked;
    for (let i = 0; i < this.houseTypeList.length; i++) {
      if (i !== index) {
        this.houseTypeList[i].thisTypeChecked = false;
      }
    }
    this.checkedHouses = [];
    this.checkedHousesChange.emit(this.checkedHouses);
    this.typeChange.emit(this.houseTypeList[index].id);
  }

  chooseHouse(house) {
    if (house.disabled) {
      return;
    }
    // 单选
    if (this.defaultHouses || !this.allowMultiSelect) {
      _.forEach(this.allHouseList, (type) => {
        _.forEach(type.houses, (item) => {
          item.checked = false;
        });
      });
      house.checked = true;
      this.checkedHouses = [
        {
          id: house.house_id,
          title: house.house_title,
        },
      ];
    } else {
      // 多选
      house.checked = !house.checked;
      if (house.checked) {
        this.checkedHouses.push({
          id: house.house_id,
          title: house.house_title,
        });
      } else {
        _.remove(this.checkedHouses, (item) => {
          return item.id === house.house_id ? true : false;
        });
      }
    }
    this.checkedHousesChange.emit(this.checkedHouses);
  }
}
